<template>
  <div class="container-fluid main-color">
    <!-- Page Title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <h4 class="page-title">Mark Assessment</h4>
        </div>
      </div>
    </div>

    <!-- Authorization Warning -->
    <div v-if="!loading && assessmentData && !canUserSubmitMarks" class="row">
      <div class="col-12">
        <div class="alert alert-warning">
          <i class="mdi mdi-alert-circle-outline me-2"></i>
          <strong>Restricted Access:</strong>
          {{ getRestrictedMessage() }}
        </div>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="loading" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body text-center py-5">
            <div class="spinner-border text-primary"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div v-if="!loading && assessmentData" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <!-- Assessment Information -->
            <h5 class="mb-3 text-primary">Assessment Information</h5>

            <!-- Row 1 -->
            <div class="row mb-3 mt-2">
              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0 ">Employee</label>
                  </div>
                  <div class="col-8">
                    <input type="text" class="form-control" :value="assessmentData.employee_info?.name || '-'"
                      disabled />
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0 ">Employee ID</label>
                  </div>
                  <div class="col-8">
                    <input type="text" class="form-control" :value="assessmentData.employee_info?.id || '-'" disabled />
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 2 -->
            <div class="row mb-3">
              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0 ">Module</label>
                  </div>
                  <div class="col-8">
                    <input type="text" class="form-control" :value="assessmentData.monthly_plan?.module?.name || '-'"
                      disabled />
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0 ">Training Date</label>
                  </div>
                  <div class="col-8">
                    <input type="text" class="form-control" :value="assessmentData.monthly_plan?.from_date "
                      disabled />
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 3 -->
            <div class="row mb-3">
              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0">Status</label>
                  </div>
                  <div class="col-8">
                    <input type="text" class="form-control" :value="getStatusText(assessmentData.status)" disabled />
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0">Trainer Name</label>
                  </div>
                  <div class="col-8">
                    <input
                      type="text"
                      class="form-control"
                      :value="assessmentData.trainers?.map(t => t.name).join(', ') || '-'"
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 4 -->
            <div class="row mb-3">
              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0">Superior</label>
                  </div>
                  <div class="col-8">
                    <input type="text" class="form-control" :value="assessmentData.supervisor_info?.name || '-'"
                      disabled />
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="row align-items-center">
                  <div class="col-4">
                    <label class="h5 mb-0">Relate HR</label>
                  </div>
                  <div class="col-8">
                    <input type="text" class="form-control" :value="assessmentData.hr_info?.name || '-'" disabled />
                  </div>
                </div>
              </div>
            </div>


            <hr />

            <!-- Questions -->
            <h5 class="mb-3 text-primary">Assessment Questions</h5>

            <div v-for="(qa, index) in assessmentData.questions_and_answers" :key="qa.answer_id" class="mb-3">
              <h5 class="fw-semibold">
                {{ index + 1 }}. {{ qa.question_details?.question_text }}
              </h5>

              <!-- Radio -->
              <div v-if="['radio', 'true_false'].includes(qa.question_details?.type)" class="mt-2">
                <div v-for="option in qa.question_details?.options || []" :key="option.id" class="form-check mb-1">
                  <input class="form-check-input" type="radio" :checked="qa.user_answer == option.id" disabled />
                  <label class=" ms-1 fw-normal">
                    {{ option.name }}
                  </label>
                </div>
              </div>

              <!-- Typing -->
              <div v-if="['typing', 'fill_in_blank'].includes(qa.question_details?.type)" class="mt-2">
               <textarea
                  class="form-control mb-1"
                  disabled
                  :value="qa.user_answer || 'No answer provided'"
                ></textarea>

                <div class="col mt-2">
                  <div class="row">
                   <div class="col-4">
                     <label for="" class="form-control">Select mark (0–10)</label>
                   </div>
                  <div class="col-4">
  <select 
    class="form-select" 
    :value="typingMarks[qa.question_details?.id] ?? ''"
    @change="setTypingMark(qa.question_details?.id, $event.target.value)"
    :disabled="isCompleted || !canUserSubmitMarks"
    :class="{'border-danger': !typingMarks[qa.question_details?.id] && typingMarks[qa.question_details?.id] !== 0}"
  >
    <option value="" disabled selected>-- Select Mark --</option>

    <option v-for="n in 11" :key="n-1" :value="n-1">
      {{ n-1 }} {{ n-1 === 1 ? 'point' : 'points' }}
    </option>
  </select>
  
  <small v-if="!isCompleted && (typingMarks[qa.question_details?.id] === undefined)" class="text-danger">
    Required
  </small>
</div>
                  </div>
                </div>
              </div>

              <span class="badge mt-2" :class="qa.mark > 0 ? 'bg-success' : 'bg-danger'">
                {{ qa.mark || 0 }} marks
              </span>

              <hr />
            </div>

            <!-- Feedback -->
            <h5 class="mt-4">Please, provide your feedback and suggestions for further improvement of this training.
            </h5>
            <textarea v-if="assessmentData.suggestion"  
              class="form-control mb-1"
              disabled
              :value="assessmentData.suggestion"
            ></textarea>

            <p v-else class="text-muted">
              No suggestion provided by the user.
            </p>

            <!-- Score Summary -->
            <div class="alert alert-info mt-4">
              <strong>Current Score:</strong>
              {{ totalMarksCalculated }} / {{ maxPossibleMarks }}
              <span class="ms-2 text-primary">
                ({{ calculatePercentage() }}%)
              </span>
            </div>

            <!-- Action Buttons -->
            <div class="text-center mt-3">
              <button class="btn btn-secondary me-3" @click="$router.push({ name: 'after-month-assessment-result' })">
                Cancel
              </button>

              <button v-if="canUserSubmitMarks && !isCompleted" class="btn btn-success px-3"
                :disabled="isLoading || !canSubmit" @click="submitMarks">
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                Save
              </button>

              <!-- <button v-else-if="isCompleted" class="btn btn-success px-3" disabled>
                Save
              </button> -->
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import userHasPermissions from "../../../mixins/userHasPermissions";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  mixins: [userHasPermissions],
  data() {
    return {
      assessmentData: null,
      typingMarks: {},
      loading: false,
      isLoading: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  computed: {
    currentUserEmployeeId() {
      const employeeId = this.$store.state.auth.user?.employee_id;
      return employeeId;
    },

    // Check for ANY of the required permissions for this route
    hasAnyRequiredPermission() {
      const requiredPermissions = ["self-assessment-result-remark"];
      const hasAny = requiredPermissions.some(perm => this.hasPermissions([perm]));
      return hasAny;
    },

    // Check if user has remark permission specifically
    hasRemarkPermission() {
      const hasPerm = this.hasPermissions(['self-assessment-result-remark']);
      return hasPerm;
    },

    // Check if current user is one of the trainers
    isCurrentUserTrainer() {
      if (!this.currentUserEmployeeId) {
        return false;
      }

      if (!this.assessmentData?.trainers) {
        return false;
      }

      // Convert trainers array to regular array
      const trainers = JSON.parse(JSON.stringify(this.assessmentData.trainers));

      const isTrainer = trainers.some(trainer => {
        return trainer.employee_id === this.currentUserEmployeeId;
      });

      return isTrainer;
    },

    // Can user submit marks?
    canUserSubmitMarks() {

      // If user is trainer AND  they can submit
      if (this.isCurrentUserTrainer) {
        return true;
      }

      // If user has remark permission specifically (admin), they can always submit
      if (this.hasRemarkPermission) {
        return true;
      }

      return false;
    },

    // Existing computed properties
    totalQuestions() {
      return this.assessmentData?.questions_and_answers?.length || 0;
    },
    isCompleted() {
      return parseInt(this.assessmentData?.status) === 2;
    },
    radioQuestionsCount() {
      return this.assessmentData?.questions_and_answers?.filter(
        qa => qa.question_details?.type === 'radio'
      ).length || 0;
    },
    typingQuestionsCount() {
      return this.assessmentData?.questions_and_answers?.filter(
        qa => ['typing', 'fill_in_blank'].includes(qa.question_details?.type)
      ).length || 0;
    },
    markedTypingQuestionsCount() {
      return Object.values(this.typingMarks).filter(val => val !== undefined && val !== '').length;
    },
    markingProgress() {
      if (this.typingQuestionsCount === 0) return 100;
      return (this.markedTypingQuestionsCount / this.typingQuestionsCount) * 100;
    },
    canSubmit() {
      const allTypingMarked = this.markedTypingQuestionsCount === this.typingQuestionsCount;
      return allTypingMarked && this.canUserSubmitMarks;
    },
    totalMarksCalculated() {
      let total = 0;

      this.assessmentData?.questions_and_answers?.forEach(qa => {
        if (['radio', 'true_false'].includes(qa.question_details?.type)) {
          total += qa.mark || 0;
        }
      });

      Object.values(this.typingMarks).forEach(mark => {
        total += parseInt(mark) || 0;
      });

      return total;
    },
    maxPossibleMarks() {
      return (this.totalQuestions * 10);
    },
  },
  methods: {
    getStatusText(status) {
      switch (parseInt(status)) {
        case 0:
          return 'Waiting';
        case 1:
          return 'On Progress';
        case 2:
          return 'Complete';
        default:
          return 'Unknown';
      }
    },

    getStatusClass(status) {
      switch (parseInt(status)) {
        case 0:
          return 'badge-warning';
        case 1:
          return 'badge-info';
        case 2:
          return 'badge-success';
        default:
          return 'badge-secondary';
      }
    },

    getQuestionTypeClass(type) {
      switch (type) {
        case 'radio':
          return 'bg-primary';
        case 'typing':
          return 'bg-success';
        default:
          return 'bg-secondary';
      }
    },

    getRestrictedMessage() {
      if (this.canUserSubmitMarks) {
        return "You are authorized to submit marks.";
      }

      if (!this.isCurrentUserTrainer) {
        return "You are not assigned as a trainer for this assessment.";
      }

      if (!this.hasAnyRequiredPermission) {
        return "You don't have the required permissions. Need either: self-assessment-result-remark";
      }

      return "You are not authorized to submit marks for this assessment.";
    },

    getButtonTitle() {
      if (!this.canUserSubmitMarks) {
        return this.getRestrictedMessage();
      }

      if (!this.canSubmit) {
        return "Please mark all typing questions before submitting.";
      }

      if (this.isCompleted) {
        return "This assessment has already been completed.";
      }

      return "Submit marks for this assessment";
    },

    setTypingMark(questionId, mark) {
  if (!questionId) return;

  if (mark === "") {
    // If they switch back to placeholder, remove the entry
    const newMarks = { ...this.typingMarks };
    delete newMarks[questionId];
    this.typingMarks = newMarks;
  } else {
    // Store the actual number (including 0)
    this.typingMarks = {
      ...this.typingMarks,
      [questionId]: parseInt(mark)
    };
  }
},
    async assessmentTimelineEdit() {
      this.loading = true;
      this.$Progress.start();
      try {
        const response = await axios.get(
          `${this.baseUrl}admin/v3/self-assessment-results/${this.$route.params.id}`
        );


        if (response.data.data) {
          this.assessmentData = response.data.data;

          this.initializeTypingMarks();

        }
        console.log('Fetched assessment data:', this.assessmentData);
        console.log('hr', this.assessmentData.hr_info.name)
        console.log('su', this.assessmentData.supervisor_info.name)
        this.loading = false;
        this.$Progress.finish();
      } catch (error) {
        console.error('Error fetching assessment:', error);
        this.toast.error("Something went wrong.");
        this.loading = false;
        this.$Progress.fail();
      }
    },

    initializeTypingMarks() {
  if (!this.assessmentData?.questions_and_answers) return;

  const marks = {};
  this.assessmentData.questions_and_answers.forEach(qa => {
    // Only pre-fill if the mark is explicitly set in the database
    // If your DB default is 0 but 0 is a valid grade, you'll need a 'is_marked' flag from backend
    if (['typing', 'fill_in_blank'].includes(qa.question_details?.type)) {
        if (qa.mark !== null && qa.mark !== undefined && this.isCompleted) {
            marks[qa.question_details.id] = qa.mark;
        }
    }
  });

  this.typingMarks = marks;
},

    calculatePercentage() {
      if (this.maxPossibleMarks === 0) return 0;
      const percentage = Math.round((this.totalMarksCalculated / this.maxPossibleMarks) * 100);
      return percentage;
    },

    async submitMarks() {
      if (!this.canUserSubmitMarks) {
        this.toast.error(this.getRestrictedMessage());
        return;
      }

      if (!this.canSubmit) {
        this.toast.warning("Please mark all typing questions before submitting.");
        return;
      }

      if (this.isCompleted) {
        this.toast.warning("This assessment has already been completed.");
        return;
      }

      this.isLoading = true;

      const submitData = {
        typing_marks: Object.keys(this.typingMarks).map(questionId => ({
          question_id: parseInt(questionId),
          mark: this.typingMarks[questionId]
        })),
        submitted_by: this.currentUserEmployeeId,
        is_trainer: this.isCurrentUserTrainer
      };

      try {
        await axios.put(
          `${this.baseUrl}admin/v3/self-assessment-marking/${this.$route.params.id}`,
          submitData,
          {
            headers: {
              Authorization: this.$store.state.auth.token
            }
          }
        );

        this.toast.success("Marks submitted successfully!");
        this.$router.push({ name: "after-month-assessment-result" });
      } catch (error) {
        console.error('Error submitting marks:', error);
        if (error.response?.data?.message) {
          this.toast.error(error.response.data.message);
        } else {
          this.toast.error("Failed to submit marks. Please try again.");
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.assessmentTimelineEdit();
  },

  watch: {
    assessmentData: {
      handler(newVal) {
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.form-control-static {
  padding: 0.375rem 0;
  margin-bottom: 0;
  min-height: 1.5em;
  border-bottom: 1px solid #dee2e6;
}

.badge {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
}

.badge-warning {
  background-color: #ffc107;
  color: #212529;
}

.badge-info {
  background-color: #17a2b8;
  color: white;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}

.bg-primary {
  background-color: #4a81d4 !important;
}

.bg-success {
  background-color: #28a745 !important;
}

.bg-danger {
  background-color: #dc3545 !important;
}

.bg-warning {
  background-color: #ffc107 !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

.options-list {
  max-height: 200px;
  overflow-y: auto;
}

.form-check-input:disabled {
  opacity: 1;
}

.marking-section {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}

.form-select {
  height: 38px;
}

.progress {
  background-color: #e9ecef;
}

.progress-bar {
  transition: width 0.3s ease;
}

.spinner-border {
  width: 1rem;
  height: 1rem;
}

.list-unstyled li {
  padding-left: 0;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.alert-success {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.current-mark .badge {
  font-size: 11px;
  padding: 4px 8px;
}
</style>